/* ============================================================
   Diva — global enhancements JS
   #6 Product-card image shimmer: mark wrappers loaded so the
   skeleton shimmer stops and the image fades in.
   Progressive enhancement: adds .js-diva to <html> so the
   image fade-in CSS only applies when JS is running.

   IMPORTANT: cards injected AFTER load (Recommended Products /
   product-recommendations API, quick view, AJAX grids, Swiper
   clones) must also be marked, otherwise their images stay at
   opacity:0 and the card looks like an empty grey box.
   ============================================================ */
(function () {
  'use strict';
  document.documentElement.classList.add('js-diva');

  function markLoaded(wrap) {
    if (wrap) wrap.classList.add('diva-img-loaded');
  }

  function watch(wrap) {
    if (!wrap || wrap.classList.contains('diva-img-loaded')) return;
    var img = wrap.querySelector('img.img-fluid, img');
    if (!img) { markLoaded(wrap); return; } // placeholder SVG etc.
    if (img.complete && img.naturalWidth > 0) { markLoaded(wrap); return; }
    img.addEventListener('load', function () { markLoaded(wrap); }, { once: true });
    img.addEventListener('error', function () { markLoaded(wrap); }, { once: true });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wraps = scope.querySelectorAll('.product-card-img-wrapper');
    for (var i = 0; i < wraps.length; i++) watch(wraps[i]);
  }

  function scanNode(n) {
    if (!n || n.nodeType !== 1) return;
    if (n.classList && n.classList.contains('product-card-img-wrapper')) watch(n);
    if (n.querySelectorAll) scan(n);
  }

  function start() {
    scan(document);

    // Catch cards inserted into the DOM after initial render.
    if (window.MutationObserver && document.body) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) scanNode(added[j]);
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-scan on theme-editor section loads and quick view
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('quick-view:loaded', function () { scan(document); });

  // Safety net: sweep after full load, and once more shortly after, so a
  // card can never be left stuck invisible if an event was missed.
  window.addEventListener('load', function () {
    scan(document);
    setTimeout(function () { scan(document); }, 1200);
  });
})();
